import { RootState } from "../../store";

export const selectOpenDashboardMenu = (state:RootState)=> state.dashboardReducer.openDashboardMenu